(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Collection-recommend"] && !Shopify.designMode) return;
  try {
     
  document.addEventListener('DOMContentLoaded', function() { 
    var swiper = new Swiper('.collections-recommend-swiper', { 
      slidesPerView: 3, 
      spaceBetween: 20, 
      loop: false,                 
      breakpoints: { 
        0: { 
          slidesPerView: 1.3, 
          spaceBetween: 10,       
          centeredSlides: false,  
        }, 
        768: { 
          slidesPerView: 3,    
          spaceBetween: 10,       
          centeredSlides: false,  
        } 
      } 
    }); 
  }); 

  } catch(e) { console.error(e); }
})();
})();
